import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import styled from 'styled-components';

export const HEADER_MOBILE = 56;
export const FOOTER_MOBILE = 66;
export const BOTTOM_NAVIGATION_ALL_SECTION_INFO_HEIGHT = 56;
export const BOTTOM_NAVIGATION_ALL_QUESTION_INFO_HEIGHT = 64;
export const BOTTOM_NAVIGATION_HEIGHT =
  BOTTOM_NAVIGATION_ALL_SECTION_INFO_HEIGHT + BOTTOM_NAVIGATION_ALL_QUESTION_INFO_HEIGHT;

export const BOTTOM_NAVIGATION_LEFT_SECTION_WIDTH = 180;
export const BOTTOM_NAVIGATION_LEFT_BOOK_WIDTH = 32;
export const BOTTOM_NAVIGATION_LEFT_BOOK_HEIGHT = 44;

export const BottomNavigationLayout = styled.section`
  z-index: 1;
  bottom: 0;
  width: 100vw;

  background: ${figmaColors.W2B1};
  box-shadow: 0 2.4583px 3.623px rgba(142, 142, 142, 0.0245),
    0 3.0157px 10.0172px rgba(142, 142, 142, 0.0414),
    0 3.6517px 24.1177px rgba(142, 142, 142, 0.0601), 0 6px 80px rgba(142, 142, 142, 0.1);

  .bottom-nav-wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
  .wrapper {
    padding-left: 32px;
    min-width: 100vw;
    height: ${BOTTOM_NAVIGATION_HEIGHT}px;
    display: flex;
    align-items: center;
  }
  .all-section-info {
    display: flex;
    align-items: center;
    padding: 6px 24px;
    &.reading-view-only {
      align-self: flex-end;
    }
    &.listening-view-only {
      justify-content: space-between;
    }
  }
  .all-question-info {
    padding: 8px 24px;
    max-width: 100vw;
    overflow: auto;
    background-color: ${colorsV2.white100};
  }
  .section {
    &-left {
      min-width: ${BOTTOM_NAVIGATION_LEFT_SECTION_WIDTH}px;
      img {
        max-height: 48px;
        object-fit: cover;
      }
    }
    &-middle {
      flex: 1;
      display: flex;
      align-items: center;
    }
    &-right {
      margin-left: 12px;
      text-align: right;
      min-width: 260px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .volume-slider {
        margin-right: 8px;
      }
      .btn-question-navigation {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        button {
          padding: 6px 16px;
        }
      }
    }
  }
  &.listening-full-test {
    .section-middle {
      justify-content: center;
    }
  }
`;
